import React, { useMemo, useState } from 'react';
import { BodyText, SecondaryButton, useModalProps } from '@kallidus/common';
import { number } from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import ContactUsModal from '@Generic/ContactUsModal';
import './CompanyTrial.less';

const getModalProps = (isRequestQuoteModal, t) => {
  return isRequestQuoteModal
    ? {
        title: t('company-trial.modals.request-quote.title-request'),
        subTitle: t('company-trial.modals.request-quote.subtitle-request'),
        message: t('company-trial.modals.request-quote.placeholder-message'),
      }
    : {
        title: t('company-trial.modals.contact-us.title-contact'),
        subTitle: t('company-trial.modals.contact-us.subtitle-contact'),
        message: t('company-trial.modals.contact-us.placeholder-message'),
      };
};

const CompanyTrialHeader = ({ trialDays }) => {
  const { t } = useTranslation();
  const [requestQuoteMOdal, setRequestQuoteModal] = useState(false);

  const { openModal, modalProps } = useModalProps();
  const contactUsModalProps = useMemo(() => getModalProps(requestQuoteMOdal, t), [requestQuoteMOdal, t]);

  const handleRequestAndContactUs = (isShowRequestModal) => {
    setRequestQuoteModal(isShowRequestModal);
    openModal();
  };

  return (
    <div className='company-trial'>
      <BodyText className='free-trial'>
        <Trans
          i18nKey='company-trial.free-trial'
          values={{
            text: `${trialDays} days`,
          }}
          components={{ bold: <strong /> }}
        />
      </BodyText>
      <SecondaryButton onClick={() => handleRequestAndContactUs(true)} className='primary'>
        {t('std-button.request-quote')}
      </SecondaryButton>
      <SecondaryButton onClick={() => handleRequestAndContactUs(false)} className='secondary'>
        {t('std-button.contact-us')}
      </SecondaryButton>
      <ContactUsModal {...contactUsModalProps} {...modalProps} />
    </div>
  );
};

CompanyTrialHeader.propTypes = {
  trialDays: number,
};

export default CompanyTrialHeader;
